import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import heroImage from "@/assets/hero-car.webp";
import { optimizeImage } from "@/lib/imageOptimizer";

// Inject preload for the LCP hero image. The <img> in HeroSection uses a
// responsive srcset (wsrv.nl variants in production, local asset in dev), so
// the preload must mirror that exact srcset + sizes — otherwise the browser
// preloads one URL and then downloads a different one for the LCP, wasting
// the preload entirely.
if (typeof document !== "undefined") {
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.type = "image/webp";
  link.fetchPriority = "high";

  const srcset = `${optimizeImage(heroImage, { width: 480, quality: 80 })} 480w, ${optimizeImage(heroImage, { width: 800, quality: 82 })} 800w, ${optimizeImage(heroImage, { width: 1280, quality: 85 })} 1280w`;
  const sizes = "(max-width: 768px) 100vw, (max-width: 1280px) 800px, 1280px";

  // imagesrcset / imagesizes are the responsive-preload equivalents of the
  // <img> srcset / sizes attributes. Setting them via setAttribute keeps
  // compatibility across browsers that don't expose the camelCase props.
  link.setAttribute("imagesrcset", srcset);
  link.setAttribute("imagesizes", sizes);
  // href is a fallback for browsers that ignore imagesrcset.
  link.href = heroImage;
  document.head.appendChild(link);
}

createRoot(document.getElementById("root")!).render(<App />);
